// Simple Custom Accordion Web Component
class CustomAccordion extends HTMLElement {
  connectedCallback() {
    const header = this.querySelector('.custom-accordion__header, .custom-accordion__toggle');

    if (header) {
      header.addEventListener('click', () => {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', !isExpanded);
        header.setAttribute('aria-expanded', !isExpanded);
      });
    }
  }
}

// Register the custom element
if (!customElements.get('custom-accordion')) {
  customElements.define('custom-accordion', CustomAccordion);
}
